import { api, unwrap } from '@/data/api/client';
import type {
  Home, NewDepositResult, NewWithdrawResult, DepositState, Poll, WalletLinks, ContactInfo,
  DepositList, WithdrawList,
} from '@/domain/types';

export const homeRepo = {
  home: () => unwrap<Home>(api.GET('/home', {})),

  walletLinks: () => unwrap<WalletLinks>(api.GET('/home/wallet/link', {})),

  contact: () => unwrap<ContactInfo>(api.GET('/home/contact', {})),

  deposits: (page = 1, pageSize = 20) =>
    unwrap<DepositList>(api.GET('/home/deposit', { params: { query: { page, pageSize } } })),

  newDeposit: (network: string, coinType: string, usdAmount: number) =>
    unwrap<NewDepositResult>(api.POST('/home/deposit/new', {
      body: { network, coinType, usdAmount },
    })),

  depositState: (depositId?: number) =>
    unwrap<DepositState>(api.GET('/home/deposit/state', {
      params: { query: depositId ? { depositId } : {} },
    })),

  withdrawals: (page = 1, pageSize = 20) =>
    unwrap<WithdrawList>(api.GET('/home/withdraw', { params: { query: { page, pageSize } } })),

  newWithdraw: (network: string, coinType: string, coinAmount: number, destinationAddress: string) =>
    unwrap<NewWithdrawResult>(api.POST('/home/withdraw/new', {
      body: { network, coinType, coinAmount, destinationAddress },
    })),

  contactUs: (title: string, contactWay: string, description: string) =>
    unwrap(api.POST('/home/contactus', { body: { title, contactWay, description } })),

  poll: () => unwrap<Poll>(api.GET('/home/poll', {})),

  submitPoll: (id: number) =>
    unwrap(api.POST('/home/poll/submit', { body: { id } })),
};
